<template>
    <el-form :model="item" ref="ruleForm" class="demo-ruleForm">
        <div>
            <div class="supplier-need" style="border: 0">
                <div class="require-detail">
                    <div v-if="item.tradeRuleList.length > 0" v-for="(tradeRule, index) in item.tradeRuleList">
                        <div class="form-single mb50" style="border-bottom: 1px dotted #EEE;margin-top:4px;margin-bottom:4px;">
                            <div class="title">{{tradeRule.name}}</div>
                            <div class="content">
                                <el-radio-group v-if="tradeRule.type == singleRuleType.value" :disabled="operate=='chakan' || tradeRule.revisable == false || tradeRule.revisable == 'false'" v-model="tradeRule.optionValue" class="radio">
                                    <el-radio class="display-block mb5" v-for="(tradeRuleOption, tradeRuleOptionIndex) in tradeRule.tradeRuleOptionList" :label="tradeRuleOption.id">
                                        <span>{{tradeRuleOption.name}}</span>
                                        <div class="inline-block ml15" v-if="tradeRuleOption.extFlag == 1">
                                            <div v-if="tradeRuleOption.code == 'Unified'">
                                                <el-form-item v-if="tradeRule.optionValue == tradeRuleOption.id" :key="tradeRuleOption.id" :prop="'tradeRuleList.' + index + '.tradeRuleOptionList.'+tradeRuleOptionIndex+'.extValue'" :rules="{validator : validateNum, trigger: 'blur'}">
                                                    <swb-pattern-input v-if="tradeRuleOption.extPattern != null" :pattern="tradeRuleOption.extPattern" :initValue="tradeRuleOption.extValue" inputType="Num" valueType="Integer" :readOnly="tradeRule.optionValue != tradeRuleOption.id || operate=='chakan' || tradeRule.revisable == false || tradeRule.revisable == 'false'" :ref="tradeRule.code"></swb-pattern-input>
                                                </el-form-item>
                                                <swb-pattern-input v-if="tradeRuleOption.extPattern != null && tradeRule.optionValue != tradeRuleOption.id" :pattern="tradeRuleOption.extPattern" :initValue="tradeRuleOption.extValue" inputType="Num" valueType="Integer" :readOnly="tradeRule.optionValue != tradeRuleOption.id || operate=='chakan' || tradeRule.revisable == false || tradeRule.revisable == 'false'" :ref="tradeRule.code"></swb-pattern-input>
                                            </div>
                                            <div v-if="tradeRuleOption.code == 'Charge' || tradeRuleOption.code == 'Plain' || tradeRuleOption.code == 'Special'">
                                                <swb-pattern-input v-if="tradeRuleOption.extPattern != null" :pattern="tradeRuleOption.extPattern" :initValue="tradeRuleOption.extValue" inputType="Text" valueType="String" :readOnly="tradeRule.optionValue != tradeRuleOption.id  || operate=='chakan' || tradeRule.revisable == false || tradeRule.revisable == 'false'" :ref="tradeRule.code"></swb-pattern-input>
                                            </div>
                                        </div>
                                        <el-radio-group :disabled="tradeRule.optionValue != tradeRuleOption.id || operate=='chakan' || tradeRule.revisable == false || tradeRule.revisable == 'false'" v-model="tradeRuleOption.optionValue" class="ml20">
                                            <el-radio class="ml15" v-for="tradeRuleSubOption in tradeRuleOption.tradeRuleSubOptionList" :label="tradeRuleSubOption.id">
                                                <span>{{tradeRuleSubOption.name}}</span>
                                            </el-radio>
                                        </el-radio-group>
                                    </el-radio>
                                </el-radio-group>
                                <el-checkbox-group v-else-if="tradeRule.type == multiRuleType.value" v-model="tradeRule.optionValueList">
                                    <el-checkbox :disabled="operate=='chakan' || tradeRule.revisable == false || tradeRule.revisable == 'false'" class="display-block mb5" v-for="tradeRuleOption in tradeRule.tradeRuleOptionList" :label="tradeRuleOption.id" @change="changeCheck(tradeRuleOption)">
                                        <span>{{tradeRuleOption.name}}</span>
                                        <el-radio-group :disabled="!tradeRuleOption.checked || operate=='chakan' || tradeRule.revisable == false || tradeRule.revisable == 'false'" v-model="tradeRuleOption.optionValue" class="ml20">
                                            <el-radio class="ml15" v-for="tradeRuleSubOption in tradeRuleOption.tradeRuleSubOptionList" :label="tradeRuleSubOption.id">
                                                <span>{{tradeRuleSubOption.name}}</span>
                                                <div class="inline-block ml15" v-if="tradeRuleSubOption.extFlag == 1 && tradeRuleSubOption.code == 'FixedOneAddress'">
                                                    <swb-pattern-input v-if="tradeRuleSubOption.extPattern != null" :pattern="tradeRuleSubOption.extPattern" :initValue="tradeRuleOption.extValue" inputType="MlText" valueType="String" :readOnly="!tradeRuleOption.checked || tradeRuleOption.optionValue != tradeRuleSubOption.id  || operate=='chakan' || tradeRule.revisable == false || tradeRule.revisable == 'false'" :ref="tradeRule.code"></swb-pattern-input>
                                                </div>
                                            </el-radio>
                                        </el-radio-group>
                                    </el-checkbox>
                                </el-checkbox-group>
                                <div v-else-if="tradeRule.type == textType.value">
                                    <el-input :disabled="operate=='chakan' || tradeRule.revisable == false || tradeRule.revisable == 'false'" type="text" v-model="tradeRule.context" style="width: 200px"></el-input>
                                </div>
                                <div v-else-if="tradeRule.type == numType.value">
                                    <el-input :disabled="operate=='chakan' || tradeRule.revisable == false || tradeRule.revisable == 'false'" type="number" v-model="tradeRule.context" style="width: 200px"></el-input>
                                </div>
                                <div v-else-if="tradeRule.type == mlTextType.value">
                                    <el-input :disabled="operate=='chakan' || tradeRule.revisable == false || tradeRule.revisable == 'false'" type="textarea" :autosize="{minRows: 3, maxRows: 5}" v-model="tradeRule.context" style="width: 450px"></el-input>
                                </div>
                            </div>
                            <!--<div v-if="tradeRule.forContract == forContract" class="">
                                    <el-checkbox v-if="isOwner" :disabled="operate=='chakan'" v-model="tradeRule.openToFstPartyShop">门店可看</el-checkbox>
                                    <el-checkbox v-if="!isOwner" :disabled="operate=='chakan'" v-model="tradeRule.openToSndPartyShop">门店可看</el-checkbox>
                                </div>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import merchtComnApi from '../../api/merchtComn'

    import SwbPatternInput from '../ctrl/PatternInput';
    Vue.regist(SwbPatternInput);

    export default {
        name: 'swb-create-trade-rule',
        desc: '交易规则',
        props: {
            id: {
                default: null
            },
            comparedTradeRuleList: {
                type: Array,
                default: []
            },
            //当选查询类型
            //例如： bid、 callBid、priceInqry、priceReply
            type: {
                type: String,
                default: null
            },
            //当前需要返回的类型
            returnType: {
                type: String,
                default: null
            },
            //当前操作
            operate: {
                type: String,
                default: null
            },
            //是否网点可看
            isOwner: {
                type: Boolean,
                default: false
            },
            //是否适用于招投标
            forBid: {
                type: Boolean,
                default: false
            },
            //是否适用于合同
            forContract: {
                type: Boolean,
                default: false
            },
            //是否适用于询价
            forPriceInqry: {
                type: Boolean,
                default: false
            },
            //是否适用于商品
            forGoods: {
                type: Boolean,
                default: false
            },
            //是否适用于服务
            forServc: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                item: {tradeRuleList: []},
                tradeRuleList: [],

                textType: {},
                numType: {},
                mlTextType: {},
                singleRuleType: {},
                multiRuleType: {},

                contractTermValueList: [],
                bidTermValueList: [],
                callBidTermValueList: []

            }
        },
        created: function () {
            this.textType = getEnumInfoWith('tradeRuleType', 'name', 'Text');
            this.numType = getEnumInfoWith('tradeRuleType', 'name', 'Num');
            this.mlTextType = getEnumInfoWith('tradeRuleType', 'name', 'MlText');

            this.singleRuleType = getEnumInfoWith("tradeRuleType", 'name', 'Single');
            this.multiRuleType = getEnumInfoWith("tradeRuleType", 'name', 'Multi');

            this.getTradeRule();
        },
        methods: {
            validateNum: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('该项不能为空或输入正确的正整数！'));
                } else {
                    if(!Utils.isNumber(value) || value <= 0) {
                        callback(new Error('该项为正整数的数值'));
                    } else {
                        callback();
                    }
                }
            },
            getTradeRule: function () {
                let self = this;
                let postData = {};
                if(self.forBid) {
                    postData.forBid = self.forBid;
                }
                if(self.forContract) {
                    postData.forContract = self.forContract;
                }
                if(self.forPriceInqry) {
                    postData.forPriceInqry = self.forPriceInqry;
                }
                if(self.forGoods) {
                    postData.forGoods = self.forGoods;
                }
                if(self.forServc) {
                    postData.forServc = self.forServc;
                }

                postData.disabled = false;
                merchtComnApi.getTradeRuleList(postData, function (result) {
                    if(result.type == 'info') {
                        let tradeRuleList = result.data;
                        if(tradeRuleList != null && tradeRuleList.length > 0) {
                            for(var i = 0; i < tradeRuleList.length; i++) {
                                let tradeRule = tradeRuleList[i];
                                tradeRule.optionValue = null; //单选选中
                                tradeRule.optionValueList = []; //多选选中
                                tradeRule.openToFstPartyShop = false; //初始甲方门店不可看
                                tradeRule.openToSndPartyShop = false; //初始乙方门店不可看
                                tradeRule.revisable = true; //默认可以修改
                                if(tradeRule.type == self.singleRuleType.value) { //单选
                                    let tradeRuleOptionList = tradeRule.tradeRuleOptionList;
                                    if(tradeRuleOptionList != null && tradeRuleOptionList.length > 0) {
                                        for(var k = 0; k < tradeRuleOptionList.length; k++) {
                                            let tradeRuleOption = tradeRuleOptionList[k];
                                            tradeRuleOption.optionValue = null;
                                            if(tradeRuleOption.defaulted) {
                                                tradeRule.optionValue = tradeRuleOption.id; //默认选中
                                            }
                                            let tradeRuleSubOptionList = tradeRuleOption.tradeRuleSubOptionList;
                                            for(var j = 0; j < tradeRuleSubOptionList.length; j++) {
                                                let tradeRuleSubOption = tradeRuleSubOptionList[j];
                                                if(tradeRuleSubOption.defaulted) {
                                                    tradeRuleOption.optionValue = tradeRuleSubOption.id; //默认选中
                                                }
                                            }
                                        }
                                    }
                                } else if(tradeRule.type == self.multiRuleType.value) { //多选
                                    let tradeRuleOptionList = tradeRule.tradeRuleOptionList;
                                    if(tradeRuleOptionList != null && tradeRuleOptionList.length > 0) {
                                        for(var k = 0; k < tradeRuleOptionList.length; k++) {
                                            let tradeRuleOption = tradeRuleOptionList[k];
                                            tradeRuleOption.optionValue = null;
                                            tradeRuleOption.checked = false;
                                            if(tradeRuleOption.defaulted) {
                                                (tradeRule.optionValueList).push(tradeRuleOption.id);//多选选中
                                                if(self.comparedTradeRuleList == null || self.comparedTradeRuleList.length == 0) { //id为空 正常的添加 有子项的子项不禁用
                                                    tradeRuleOption.checked = true;
                                                }
                                            }
                                            let tradeRuleSubOptionList = tradeRuleOption.tradeRuleSubOptionList;
                                            for(var j = 0; j < tradeRuleSubOptionList.length; j++) {
                                                let tradeRuleSubOption = tradeRuleSubOptionList[j];
                                                if(tradeRuleSubOption.defaulted) {
                                                    tradeRuleOption.optionValue = tradeRuleSubOption.id;//单选选中
                                                }
                                            }
                                        }
                                    }
                                } else {
                                    tradeRule.context = null; //文本
                                }
                            }
                        }
                        if(self.comparedTradeRuleList != null && self.comparedTradeRuleList.length > 0) {
                            self.getObjectTermList(tradeRuleList);
                        } else {
                            self.item.tradeRuleList = tradeRuleList;
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getObjectTermList: function (tradeRuleList) {
                let self = this;
                let objectTermList = self.comparedTradeRuleList;
                if(objectTermList != null && objectTermList.length > 0) {
                    self.getObjectTerm(tradeRuleList, objectTermList);
                }
                self.item.tradeRuleList = tradeRuleList;
            },
            getObjectTerm: function (tradeRuleList, objectTermList) {
                let self = this;
                let removeFalg = false;
                for(var j = 0; j < tradeRuleList.length; j++) {
                    removeFalg = false;
                    for(var i = 0; i < objectTermList.length; i++) {
                        let objectTerm = objectTermList[i];
                        let tradeRule = tradeRuleList[j];
                        if(objectTerm.ruleId == tradeRule.id) {
                            tradeRule.termId = objectTerm.id;
                            if(objectTerm.needed == null) {
                                tradeRule.needed = false;
                            } else {
                                tradeRule.needed = objectTerm.needed;
                            }
                            /*       tradeRule.openToFstPartyShop = objectTerm.openToFstPartyShop;
                             tradeRule.openToSndPartyShop = objectTerm.openToSndPartyShop;*/
                            tradeRule.revisable = objectTerm.revisable;
                            tradeRule.openToFstPartyShop = false;
                            tradeRule.openToSndPartyShop = false;
                            if(self.comparedTradeRuleList != null && self.comparedTradeRuleList.length > 0 && (self.type == null || self.type == '')) {
                                tradeRule.contractId = objectTerm.contractId;
                                tradeRule.seqNo = objectTerm.seqNo;
                                let contractTermValueList = objectTerm.contractTermValueList;
                                self.getObjectTermValueList(tradeRule, objectTerm, contractTermValueList);
                            } else if(self.comparedTradeRuleList != null && self.comparedTradeRuleList.length > 0 && self.type == 'bid') {
                                tradeRule.docId = objectTerm.docId;
                                tradeRule.callId = objectTerm.callId;
                                tradeRule.callDocId = objectTerm.callDocId;
                                let bidTermValueList = objectTerm.bidTermValueList;
                                self.getObjectTermValueList(tradeRule, objectTerm, bidTermValueList);
                            } else if(self.comparedTradeRuleList != null && self.comparedTradeRuleList.length > 0 && self.type == 'callBid') {
                                tradeRule.docId = objectTerm.docId;
                                let callBidTermValueList = objectTerm.callBidTermValueList;
                                self.getObjectTermValueList(tradeRule, objectTerm, callBidTermValueList);
                            } else if(self.comparedTradeRuleList != null && self.comparedTradeRuleList.length > 0 && self.type == 'priceInqry') {
                                tradeRule.voucherId = objectTerm.voucherId;
                                let termValList = objectTerm.termValList;
                                self.getObjectTermValueList(tradeRule, objectTerm, termValList);
                            }
                            else if(self.comparedTradeRuleList != null && self.comparedTradeRuleList.length > 0 && self.type == 'priceReply') {
                                tradeRule.voucherId = objectTerm.voucherId;
                                tradeRule.inqryId = objectTerm.inqryId;
                                tradeRule.inqryVoucherId = objectTerm.inqryVoucherId;
                                let priceReplyTermValueList = objectTerm.priceReplyTermValueList;
                                self.getObjectTermValueList(tradeRule, objectTerm, priceReplyTermValueList);
                            } else if(self.comparedTradeRuleList != null && self.comparedTradeRuleList.length > 0 && self.type == 'priceInqry') {
                                objectTerm.id = tradeRule.termId;
                                objectTerm.voucherId = tradeRule.voucherId;
                            }
                            else if(self.comparedTradeRuleList != null && self.comparedTradeRuleList.length > 0 && self.type == 'priceReply') {
                                objectTerm.id = tradeRule.termId;
                                objectTerm.inqryId = tradeRule.inqryId;
                                objectTerm.inqryVoucherId = tradeRule.inqryVoucherId;
                                objectTerm.voucherId = tradeRule.voucherId;
                            }
                            if(!Utils.isNoB(objectTerm.replyContent)) {
                                tradeRule.context = objectTerm.replyContent;
                            } else {
                                tradeRule.context = objectTerm.termContent;
                            }
                            removeFalg = true;
                            continue;
                        }
                    }
                    if(!removeFalg) {
                        tradeRuleList.remove(tradeRuleList[j]);
                        j--;
                    }
                }
            },
            getObjectTermValueList: function (tradeRule, objectTerm, objectTermValueList) {
                let self = this;
                tradeRule.optionValueList = [];
                for(var g = 0; g < objectTermValueList.length; g++) {
                    let objectTermValue = objectTermValueList[g];
                    if(objectTermValue.ruleOptionId != null) {
                        let tradeRuleOptionList = tradeRule.tradeRuleOptionList;
                        for(var k = 0; k < tradeRuleOptionList.length; k++) {
                            let tradeRuleOption = tradeRuleOptionList[k];
                            if(tradeRule.type == self.singleRuleType.value && objectTermValue.subOptionCode == null) {
                                tradeRuleOption.termValueId = objectTermValue.id;
                                tradeRuleOption.termId = objectTermValue.termId;
                            }
                            if(objectTermValue.ruleOptionCode == tradeRuleOption.code) {
                                tradeRuleOption.termValueId = objectTermValue.id;
                                tradeRuleOption.termId = objectTermValue.termId;
                                if(tradeRuleOption.extValue == null) {
                                    tradeRuleOption.extValue = objectTermValue.extValue;
                                }
                                if(objectTermValue.ruleOptionId == tradeRuleOption.id) {
                                    if(objectTerm.ruleType == self.singleRuleType.value) {
                                        tradeRule.optionValue = tradeRuleOption.id;
                                    } else if(objectTerm.ruleType == self.multiRuleType.value) {
                                        (tradeRule.optionValueList).push(tradeRuleOption.id);
                                        tradeRuleOption.checked = true;
                                    }
                                    if(tradeRuleOption.extValue == null) {
                                        tradeRuleOption.extValue = objectTermValue.extValue;
                                    }
                                }
                                if(objectTermValue.subOptionId != null) {
                                    let tradeRuleSubOptionList = tradeRuleOption.tradeRuleSubOptionList;
                                    for(var m = 0; m < tradeRuleSubOptionList.length; m++) {
                                        let tradeRuleSubOption = tradeRuleSubOptionList[m];
                                        if(objectTermValue.subOptionId == tradeRuleSubOption.id) {
                                            tradeRuleOption.optionValue = tradeRuleSubOption.id;
                                        }
                                        if(tradeRuleSubOption.code == "FixedOneAddress" && tradeRuleOption.extValue == null) {
                                            tradeRuleOption.extValue = objectTermValue.extValue;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            },
            getResult: function () {
                let self = this;
                let type = self.type;
                let result = {};
                //
                let tradeRuleList = self.item.tradeRuleList;
                let objectTermList = [];
                if(tradeRuleList != null && tradeRuleList.length > 0) {
                    for(var i = 0; i < tradeRuleList.length; i++) {
                        let tradeRule = tradeRuleList[i];
                        let objectTerm = {};
                        objectTerm.ruleId = tradeRule.id;
                        objectTerm.ruleCode = tradeRule.code;
                        objectTerm.ruleType = tradeRule.type;
                        objectTerm.termName = tradeRule.name;
                        objectTerm.needed = tradeRule.needed;
                        objectTerm.openToFstPartyShop = tradeRule.openToFstPartyShop;
                        objectTerm.openToSndPartyShop = tradeRule.openToSndPartyShop;
                        objectTerm.revisable = tradeRule.revisable;
                        objectTerm.replyContent = tradeRule.context;
                        if(self.comparedTradeRuleList != null && self.comparedTradeRuleList.length > 0 && (type == null || type == '')) {
                            objectTerm.id = tradeRule.termId;
                            objectTerm.contractId = tradeRule.contractId;
                        } else if(self.comparedTradeRuleList != null && self.comparedTradeRuleList.length > 0 && self.type == 'bid') {
                            objectTerm.id = tradeRule.termId;
                            objectTerm.docId = tradeRule.docId;
                            objectTerm.callId = tradeRule.callId;
                            objectTerm.callDocId = tradeRule.callDocId;
                        }
                        else if(self.comparedTradeRuleList != null && self.comparedTradeRuleList.length > 0 && self.type == 'callBid') {
                            if(self.returnType == 'bid') {
                                objectTerm.callId = tradeRule.termId;
                                objectTerm.callDocId = tradeRule.docId;
                            } else {
                                objectTerm.id = tradeRule.termId;
                                objectTerm.docId = tradeRule.docId;
                            }

                        }
                        else if(self.comparedTradeRuleList != null && self.comparedTradeRuleList.length > 0 && self.type == 'priceInqry') {
                            if(self.returnType == 'priceReply') {
                                objectTerm.inqryId = tradeRule.termId;
                                objectTerm.inqryVoucherId = tradeRule.voucherId;
                            } else {
                                objectTerm.id = tradeRule.termId;
                                objectTerm.voucherId = tradeRule.voucherId;
                            }
                        }
                        else if(self.comparedTradeRuleList != null && self.comparedTradeRuleList.length > 0 && self.type == 'priceReply') {
                            objectTerm.id = tradeRule.termId;
                            objectTerm.inqryId = tradeRule.termId;
                            objectTerm.inqryVoucherId = tradeRule.voucherId;
                            objectTerm.voucherId = tradeRule.voucherId;
                        }

                        let tradeRuleOptionList = tradeRule.tradeRuleOptionList;
                        self.getReturnValue(tradeRule, tradeRuleOptionList);
                        if(self.type == 'bid') {
                            objectTerm.bidTermValueList = tradeRule.bidTermValueList;
                        } else if(self.type == 'callBid') {
                            objectTerm.callBidTermValueList = tradeRule.callBidTermValueList;
                        } else if(self.type == 'priceInqry') {
                            objectTerm.termValList = tradeRule.termValList;
                        } else if(self.type == 'priceReply') {
                            objectTerm.priceReplyTermValueList = tradeRule.priceReplyTermValueList;
                        } else {
                            objectTerm.contractTermValueList = tradeRule.contractTermValueList;
                        }
                        objectTermList.push(objectTerm);
                    }
                }
                self.item.tradeRuleList = tradeRuleList;
                self.$refs['ruleForm'].validate(function (valid) {
                    if(valid) {
                        result.type = 'info';
                        result.data = objectTermList;
                    } else {
                        result.type = 'warn';
                        result.message = '校验失败';
                    }
                });
                return result;
            },
            getReturnValue: function (tradeRule, tradeRuleOptionList, optionValue) {
                let self = this;
                if(self.type == 'bid') {
                    tradeRule.bidTermValueList = [];
                } else if(self.type == 'callBid') {
                    tradeRule.callBidTermValueList = [];
                } else if(self.type == 'priceInqry') {
                    tradeRule.termValList = [];
                } else if(self.type == 'priceReply') {
                    tradeRule.priceReplyTermValueList = [];
                } else {
                    tradeRule.contractTermValueList = [];
                }
                if(tradeRuleOptionList != null && tradeRuleOptionList.length > 0) {
                    for(var k = 0; k < tradeRuleOptionList.length; k++) {
                        let tradeRuleOption = tradeRuleOptionList[k];
                        if(optionValue == null) {
                            optionValue = tradeRule.optionValue;
                        }
                        if((tradeRule.type == self.singleRuleType.value && optionValue == tradeRuleOption.id)
                            || (tradeRule.type == self.multiRuleType.value && true == tradeRuleOption.checked)) {
                            let objectTermValue = {};
                            if(tradeRuleOption.extFlag == 1) {
                                if(self.$refs[tradeRule.code] != null && self.$refs[tradeRule.code].length > 0) {
                                    let extValue = self.$refs[tradeRule.code][0].getValue() || null;
                                    objectTermValue.extValue = extValue;
                                    tradeRuleOption.extValue = extValue;
                                }
                            }
                            objectTermValue.ruleId = tradeRule.id;
                            objectTermValue.ruleOptionId = tradeRuleOption.id;
                            objectTermValue.ruleOptionCode = tradeRuleOption.code;
                            objectTermValue.ruleOptionName = tradeRuleOption.name;
                            objectTermValue.extFlag = tradeRuleOption.extFlag;
                            objectTermValue.hasSubOptions = false;
                            objectTermValue.seqNo = tradeRuleOption.seqNo;
                            if(self.comparedTradeRuleList != null && self.comparedTradeRuleList.length > 0) {
                                objectTermValue.id = tradeRuleOption.termValueId;
                                objectTermValue.termId = tradeRuleOption.termId;
                            }
                            let tradeRuleSubOptionList = tradeRuleOption.tradeRuleSubOptionList;
                            for(var j = 0; j < tradeRuleSubOptionList.length; j++) {
                                let tradeRuleSubOption = tradeRuleSubOptionList[j];
                                if(tradeRuleOption.optionValue == tradeRuleSubOption.id) {
                                    objectTermValue.hasSubOptions = true;
                                    objectTermValue.subOptionId = tradeRuleSubOption.id;
                                    objectTermValue.subOptionCode = tradeRuleSubOption.code;
                                    objectTermValue.subOptionName = tradeRuleSubOption.name;
                                }
                                if(tradeRuleSubOption.extFlag == 1) {
                                    if(self.$refs[tradeRule.code] != null && self.$refs[tradeRule.code].length > 0) {
                                        let extValue = self.$refs[tradeRule.code][0].getValue() || null;
                                        objectTermValue.extValue = extValue;
                                        tradeRuleSubOption.extValue = extValue;
                                    }
                                }
                            }
                            if(self.type == 'bid') {
                                tradeRule.bidTermValueList.push(objectTermValue);
                            } else if(self.type == 'callBid') {
                                tradeRule.callBidTermValueList.push(objectTermValue);
                            } else if(self.type == 'priceInqry') {
                                tradeRule.termValList.push(objectTermValue);
                            } else if(self.type == 'priceReply') {
                                tradeRule.priceReplyTermValueList.push(objectTermValue);
                            } else {
                                tradeRule.contractTermValueList.push(objectTermValue);
                            }
                        }
                    }
                }
            },
            changeCheck: function (value) {
                if(value.checked) {
                    value.checked = false;
                } else {
                    value.checked = true;
                }
            }
        }
    }
</script>

<style>
    .el-checkbox + .el-checkbox {
        margin-left: 0;
    }

    .radio .el-radio + .el-radio {
        margin-left: 0;
    }
</style>



// WEBPACK FOOTER //
// src/compo/tradeRule/CreateTradeRule.vue